import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 301 277",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M266.709 71.0766V38.0221C266.709 26.5723 257.428 17.291 245.978 17.291H212.929",
      stroke: "currentColor",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24.291 205.928V238.978C24.291 250.428 33.5721 259.709 45.0218 259.709H78.0714",
      stroke: "currentColor",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M212.924 259.709H245.974C257.424 259.709 266.705 250.428 266.705 238.978V205.928",
      stroke: "currentColor",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M78.0757 17.291H45.0218C33.5721 17.291 24.291 26.5723 24.291 38.0221V71.0723",
      stroke: "currentColor",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }